import isArray from "lodash/isArray";
import isNil from "lodash/isNil";
import { Select, SelectProps } from "PFComponents/select";
import { FilterWithDefaults, Id } from "PFTypes";

import { areFilterValuesEqual, letFilterRestore } from "../../use_filtered_collection";
import { createDropdownId } from "./filters.utils";
import { useDropdownWidth } from "./use_dropdown_width";
import { OptionOriginal, useFiltersOptions } from "./use_filters_options";

type SelectOneItemProps = SelectProps<OptionOriginal> & {
  filter: FilterWithDefaults;
  onChange: (id: Id | null, value?: OptionOriginal | null) => void;
  searchId?: number;
  disabled?: boolean;
};

export const SelectOneItem = ({ filter, onChange, disabled, labelIcons, searchId }: SelectOneItemProps) => {
  const value = (isArray(filter.value) ? filter.value[0] : filter.value) as number;
  const letRestore = letFilterRestore(filter);
  const letClear = !isNil(value) && !filter.required;

  const { dropdownWidth, ref } = useDropdownWidth();

  const { optionsProps, renderDisplayValue } = useFiltersOptions({ filter });

  const handleChange = (newValue) =>
    !areFilterValuesEqual(newValue.id, value) && onChange(newValue.id, newValue.original);
  const handleClear = () => onChange(null);

  return (
    <Select<OptionOriginal>
      ref={ref}
      disabled={filter.disabled || disabled}
      label={filter.title}
      labelIcons={labelIcons}
      required={filter.required}
      value={value}
      onChange={handleChange}
      onRestore={letRestore ? () => onChange((filter.defaultValue ?? filter.default_value) as Id) : undefined}
      onClear={letClear ? handleClear : undefined}
      dropdownId={createDropdownId(filter)}
      searchId={searchId}
      renderDisplayValue={renderDisplayValue}
      dropdownWidth={dropdownWidth}
      clipOptionsOverflow={false}
      {...optionsProps}
    />
  );
};
